// extracted by mini-css-extract-plugin
module.exports = {"group":"styles_group__DG8up","label":"styles_label__rNYxi","spendingLimit":"styles_spendingLimit__GD1oK"};